export enum StatusCondition {
  DENIED = 'DENIED',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  Queried = 'Queried',
}
